var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGridLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4004 12.8004C10.8422 12.8004 11.2004 13.1586 11.2004 13.6004V20.8004C11.2004 21.2422 10.8422 21.6004 10.4004 21.6004H3.20039C2.75856 21.6004 2.40039 21.2422 2.40039 20.8004V13.6004C2.40039 13.1586 2.75856 12.8004 3.20039 12.8004H10.4004ZM20.8004 12.8004C21.2422 12.8004 21.6004 13.1586 21.6004 13.6004V20.8004C21.6004 21.2422 21.2422 21.6004 20.8004 21.6004H13.6004C13.1586 21.6004 12.8004 21.2422 12.8004 20.8004V13.6004C12.8004 13.1586 13.1586 12.8004 13.6004 12.8004H20.8004ZM4.00039 20.0004H9.60039V14.4004H4.00039V20.0004ZM14.4004 20.0004H20.0004V14.4004H14.4004V20.0004ZM10.4004 2.40039C10.8422 2.40039 11.2004 2.75856 11.2004 3.20039V10.4004C11.2004 10.8422 10.8422 11.2004 10.4004 11.2004H3.20039C2.75856 11.2004 2.40039 10.8422 2.40039 10.4004V3.20039C2.40039 2.75856 2.75856 2.40039 3.20039 2.40039H10.4004ZM20.8004 2.40039C21.2422 2.40039 21.6004 2.75856 21.6004 3.20039V10.4004C21.6004 10.8422 21.2422 11.2004 20.8004 11.2004H13.6004C13.1586 11.2004 12.8004 10.8422 12.8004 10.4004V3.20039C12.8004 2.75856 13.1586 2.40039 13.6004 2.40039H20.8004ZM4.00039 9.60039H9.60039V4.00039H4.00039V9.60039ZM14.4004 9.60039H20.0004V4.00039H14.4004V9.60039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGridLarge);
export default __webpack_public_path__ + "static/media/icon-grid-large.c03252d2a8798f43c9072b7041272043.svg";
export { ForwardRef as ReactComponent };